import React, { useEffect, useState } from "react";
import { Button, Col, Form, Row, Spin } from "antd";
import { FormBox, InputBox } from "../../../../components/AntdAddons";
import { validations } from "../../../../config/validations/validations";
import dayjs from "dayjs";
import { CONSTANT } from "../../../../config/Constant";
import SVGIcon from "../../../../utils/SVGIcon";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../../../store/app";
import { getProviderListCode } from "../../../../store/SendMessageSlice";
import { addNumberManagement } from "../../../../store/NumberManagementSlice";
import { useNavigate } from "react-router-dom";

const NumberForm: React.FC<any> = ({ getList, messageAction }) => {
  const [form] = Form.useForm();
  const dispatch: AppDispatch = useDispatch();

  const [networkTypeAction, setNetworkTypeAction] = useState<string>("");
  const [numberTypeAction, setNumberTypeAction] = useState<string>("S");
  const [loading, setLoading] = useState<boolean>(false);
  const [providerListCode, setProviderListCode] = useState<any>();

  const userDetails = localStorage.getItem("userDetails");
  const userName = userDetails ? JSON.parse(userDetails)?.username : null;
  const navigate = useNavigate();

  const updateProviderListCode = () => {
    dispatch(getProviderListCode())
      .then((res: any) => {
        const listOfProviders = res?.data
          .filter((item) => item?.id)
          .reduce((acc, current) => {
            const x = acc.find((item) => item.id === current.id);
            if (!x) {
              return acc.concat([current]);
            } else {
              return acc;
            }
          }, []);
        listOfProviders && setProviderListCode(listOfProviders);
      })
      .catch((error: any) => {
        setProviderListCode([]);
      });
  };

  const CheckAction = (payload: any) => {
    dispatch(addNumberManagement(payload))
      .then((res: any) => {
        form.resetFields();
        setLoading(false);
        getList();
      })
      .catch((error: any) => {
        setLoading(false);
        getList();
      });
  };
  // const InquireNumberAction = (payload: any) => {
  //   dispatch(fetchInquireNumberAction(payload))
  //     .then((res: any) => {
  //       form.resetFields();
  //       setLoading(false);
  //     })
  //     .catch((error: any) => {
  //       setLoading(false);
  //     });
  // };

  const handleSubmit = async (data) => {
    setLoading(true);
    // if (data?.message_action === 'Check') {
    const payload = {
      current_provider_code: data?.current_provider_code,
      network_type: data?.network_type,
      phone_number: data?.phone_number,
      to_number: data?.to_number ?? "",
      number_type: data?.number_type2 || data?.number_type1,
      number_ownership: {
        identification1: data?.identification1,
        identification2: data?.identification2,
        identification3: data?.identification3,
        added_by: userName,
        updated_by: userName,
      },
    };

    CheckAction(payload);
    // } else if (data?.message_action === 'Inquire_number') {
    //   const inquireyPayload = {
    //     number: data?.number,
    //     to_provider: data?.to_provider,
    //   };
    //   // InquireNumberAction(inquireyPayload);
    //   InquireNumber(inquireyPayload);
    // }
  };
  // for validation
  const handleChange = () => {
    form
      .validateFields()
      .then(() => {
        // setDisable(false);
      })
      .catch((error: any) => {
        // setDisable(true);
      });
  };
  const runWebSocket = (ws: any) => {
    ws.onopen = function () {
      console.log("WebSocket connection established");
    };

    ws.onclose = function () {
      console.log("WebSocket connection closed");
    };

    ws.onmessage = function (event) {
      const eventData = JSON.parse(event.data);
      const token = localStorage.getItem("token");
      if (token === null) {
        navigate("/login");
      }

      const getNumber = eventData?.user_id || eventData?.user_id1;

      if (getNumber) {
        getList();
      } else {
        ws.close();
      }
    };
  };

  // const disabledDate: RangePickerProps['disabledDate'] = (current) => {
  //   // Can not select days before today and today
  //   return current && current > dayjs().endOf('day');
  // };
  useEffect(() => {
    form.setFieldValue("current_time", dayjs(new Date()).format(CONSTANT.DATE_TIME_FORMAT));
    form.setFieldValue(
      "transfer_time",
      dayjs(new Date()).add(15, "m").format(CONSTANT.DATE_TIME_FORMAT)
    );
  }, [form]);

  useEffect(() => {
    form.setFieldValue("message_action", messageAction);
  }, [form, messageAction]);

  useEffect(() => {
    const ws = new WebSocket(CONSTANT.WS_URL);
    runWebSocket(ws);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <FormBox
        className="filterForm"
        form={form}
        onFinish={handleSubmit}
        onChange={handleChange}
        validateTrigger={["onBlur", "onInput"]}
        autoComplete="off"
      >
        <Row gutter={[20, 0]} align={"bottom"}>
          <Col xs={24} md={12} lg={6} xxl={6}>
            <InputBox.Select
              label="Provider"
              name={"current_provider_code"}
              allowClear
              showSearch
              placeholder="Select Provider Code"
              tooltip="Select on from provided network provider list"
              onFocus={() => (providerListCode?.length > 0 ? null : updateProviderListCode())}
              notFoundContent={providerListCode?.length > 0 ? null : <Spin />}
              options={{
                list: providerListCode && providerListCode,
                valueKey: "id",
                textKey: "provider_code",
              }}
              required
              rules={[validations.required.select("Provider Code")]}
            />
          </Col>
          <Col xs={24} md={12} lg={6} xxl={6}>
            <InputBox.Select
              label="Network Type"
              name={"network_type"}
              placeholder="Select Network Type"
              tooltip={
                <>
                  For cellular number, the value must be <strong>M</strong>. <br />
                  For a fixed number (landline) the value must be <strong>F</strong>.
                </>
              }
              options={{
                list: CONSTANT.NETWORK_TYPE,
                valueKey: "id",
                textKey: "value",
              }}
              onChange={(val: string) => {
                setNetworkTypeAction(val);
              }}
              required
              rules={[validations.required.select("Network Type")]}
            />
          </Col>

          {networkTypeAction === "M" ? (
            <Col xs={24} md={12} lg={6} xxl={6}>
              <InputBox.Text
                disabled
                label="Number Type"
                name={"number_type1"}
                placeholder="Select Number Type"
                value={"I"}
                initialValue={"I"}
                tooltip={
                  <>
                    For cellular the value must be <strong>I</strong>.
                  </>
                }
              />
            </Col>
          ) : (
            networkTypeAction === "F" && (
              <Col xs={24} md={12} lg={6} xxl={6}>
                <InputBox.Select
                  label="Number Type"
                  name="number_type2"
                  placeholder="Select Number Type"
                  initialValue={"S"}
                  tooltip={
                    <>
                      Single number must be <strong>S</strong>. <br />
                      Range of numbers must be <strong>R</strong>.
                    </>
                  }
                  options={{
                    list: CONSTANT.NUMBER_TYPE,
                    valueKey: "id",
                    textKey: "value",
                  }}
                  onChange={(val: string) => {
                    setNumberTypeAction(val);
                  }}
                />
              </Col>
            )
          )}

          <Col xs={24} md={12} lg={6} xxl={6}>
            <InputBox.Text
              label="Number"
              name={"phone_number"}
              tooltip="A single phone number to request to be ported.
                    Must be in a domestic form (e.g. 0551234567 or 03123456)"
              required
              rules={[
                validations.required.text("Number"),
                validations.pattern.multiplenumber,
                // validations.pattern.numericWithSecial,
                // validations.pattern.whitespace,
              ]}
            />
          </Col>

          {networkTypeAction === "F" && numberTypeAction === "R" ? (
            <Col xs={24} md={12} lg={6} xxl={6}>
              <InputBox.Text
                label="To Number"
                name={"to_number"}
                tooltip="The end of a ranged fixed (landline) number.
                  Must be in a domestic form (e.g. 0312359)."
                required
                rules={[
                  validations.required.text("To Number"),
                  validations.pattern.numericWithSecial,
                  // validations.pattern.whitespace,
                ]}
              />
            </Col>
          ) : null}
          <Col xs={24} md={12} lg={6} xxl={6}>
            <InputBox.Text
              label="Identification Value"
              name={"identification1"}
              tooltip="Place 0 here or 123456782 (as valid I.D. number that does not exist)."
              required
              rules={[
                validations.required.text("Identification Value"),
                validations.pattern.whitespace,
              ]}
            />
          </Col>
          <Col xs={24} md={12} lg={6} xxl={6}>
            <InputBox.Text
              label="Identification Value 2nd"
              name={"identification2"}
              tooltip="Place 0 here or 123456782 (as valid I.D. number that does not exist)."
              rules={[validations.pattern.whitespace]}
            />
          </Col>
          <Col xs={24} md={12} lg={6} xxl={6}>
            <InputBox.Text
              label="Identification Value 3rd"
              name={"identification3"}
              tooltip="Place 0 here or 123456782 (as valid I.D. number that does not exist)."
              rules={[validations.pattern.whitespace]}
            />
          </Col>
        </Row>
        <Row gutter={[20, 20]} className="mt-20">
          <Col xs={12} md={12} lg={6} xl={3}>
            <Button type="primary" htmlType="submit" loading={loading}>
              <SVGIcon icon="add" color="#fff" width={55} /> Add
            </Button>
          </Col>
          <Col xs={12} md={12} lg={6} xl={3}>
            <Button
              type="default"
              // htmlType="reset"
              onChange={() => {
                form.resetFields();
                const update = {
                  current: 1,
                  page_size: 10,
                };
                getList(update);
              }}
            >
              Clear
            </Button>
          </Col>
        </Row>
      </FormBox>
    </>
  );
};

export default NumberForm;
